export class EntityReference {
  id: number
  dtoType: string
  _repr_?: string
  constructor(dtoType: string, id?: number, _repr_?: string) {
    this.id = id
    this.dtoType = dtoType
    this._repr_ = _repr_
  }
}
